export default ({ api, fetch, fetchExternal, history }) => ({
  api,
  fetch,
  fetchExternal,
  history,
});
